import type { ISystem } from '../types';

export function getSystemInfo(gdpr = false): ISystem {
  return {
    ba: gdpr ? navigator.userAgent: '',
    bb: navigator.platform,
    bc: navigator.cookieEnabled,
    bd: navigator.doNotTrack ?? 'null',
    be: navigator.onLine,
    bf: navigator.appName,
    bg: navigator.appVersion,
    bh: navigator.appCodeName,
    bi: navigator.product,
    bj: navigator.vendor,
    bk: navigator.webdriver,
  }
}
